import React from 'react';
import { FaFileAlt, FaFileCsv } from 'react-icons/fa';
import { MdFileDownload } from 'react-icons/md';
import styled from 'styled-components';
import { handleDownloadMedia } from '../../utils';

export function FileMessageBallon({ source, description, sourceType = '' }) {
  const getFileName = () => {
    const byDesc = description?.split('_upload_atendente_')[0];
    if (byDesc && byDesc.trim()) return byDesc;
    try {
      const path = new URL(source, window.location.origin).pathname;
      const name = decodeURIComponent(path.split('/').pop() || 'arquivo');
      return name || 'arquivo';
    } catch {
      const parts = (source || '').split('/');
      return decodeURIComponent(parts.pop() || 'arquivo');
    }
  };

  const fileName = getFileName();
  const ext = (fileName.split('.').pop() || '').toLowerCase();
  const isImage = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(
    ext
  );
  const isPdf = ext === 'pdf';

  const isCsv = ext === 'csv';

  const openInNewTab = (e) => {
    e.stopPropagation();
    window.open(source, '_blank');
  };

  const onKeyDownOpen = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openInNewTab(e);
    }
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    handleDownloadMedia(source, ext, sourceType);
  };

  return (
    <Container
      role="button"
      tabIndex={0}
      onKeyDown={onKeyDownOpen}
      onClick={openInNewTab}
      title={fileName}
    >
      <ThumbWrapper>
        {isImage ? (
          <Thumbnail src={source} alt={fileName} />
        ) : isCsv ? (
          <IconCircle data-file-ext={ext} isCsv={isCsv}>
            <FaFileCsv size="18" color={isPdf ? '#B00020' : '#6A5ACD'} />
          </IconCircle>
        ) : (
          <IconCircle data-file-ext={ext} isPdf={isPdf}>
            <FaFileAlt size="18" color={isPdf ? '#B00020' : '#6A5ACD'} />
          </IconCircle>
        )}
      </ThumbWrapper>

      <TextArea>
        <LabelNameFile className="hover-underline">{fileName}</LabelNameFile>
      </TextArea>

      <LabelDownloadFile
        className="hover-underline"
        onClick={handleDownload}
        title="Baixar arquivo"
      >
        <MdFileDownload size="18" />
      </LabelDownloadFile>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #eee;
  background: #ffffff;

  &:hover {
    background-color: #f8f9ff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    cursor: pointer;
  }

  &:hover .hover-underline {
    text-decoration: underline;
  }
`;

const ThumbWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f2f2;
  flex-shrink: 0;
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const IconCircle = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${({ isPdf, isCsv }) =>
    isPdf
      ? 'rgba(176, 0, 32, 0.08)'
      : isCsv
      ? 'rgba(106, 90, 205, 0.08)'
      : '#f2f2f2'};
`;

const TextArea = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
`;

const LabelNameFile = styled.label`
  cursor: pointer;
  font-size: 14px;
  color: #1f1f1f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LabelDownloadFile = styled.button`
  margin-left: auto;
  cursor: pointer;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #6a5acd;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background-color: rgba(106, 90, 205, 0.1);
  }
`;
